export default __webpack_public_path__ + "static/media/c-32.d5553aca.svg";